module.exports = __webpack_public_path__ + "static/img/29.c79eb0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/29.png
// module id = Id51
// module chunks = 0